module.exports = __webpack_public_path__ + "images/91deba2.png";